module.exports = __webpack_public_path__ + "img/2.fec8c121.jpg";